const api = 'https://api.gemsbihar.co.in';
export const environment = {
  production: false,
  apiUrl: `${api}/api/v1/`,
  payrollUrl: `/payrollApp`,
  emailApiUrl: `/mailApp`,
  processApiUrl: '/processApp/',
  version: 3.3,
};
